<div class="story-flow-view__box view-box-media outline-none" tabindex="1" (keyup.enter)="handleComKeyEnter()" role="region" aria-label="Media Upload Section" [ngClass]="{'current': !viewmodel.isStoryCreating}">
    <div class="view-box-media__tab" *ngIf="filterTabObj.items.length <= 1 && isGalleryActivated">
        <div class="view-box-media__tab-item">
            <span class="view-box-media__tab-link" *ngIf="!searchBarVisible" (click)="showSearchBar()" role="button" tabindex="0" aria-label="Search for images">
                Search for images
                <i class="fas fa-search" style="padding-left: 5px" aria-hidden="true"></i></span>
            <div class="search-input" *ngIf="searchBarVisible">
                <input id="searchUnsplash" [formControl]="searchText" type="text" placeholder="Search images" class="form-control" autofocus aria-label="Search images input">
            </div>
            <div class="pixabay-label" *ngIf="searchBarVisible" aria-label="Source of images">
                From <a target="_blank" href="https://pixabay.com/" aria-label="Pixabay website">Pixabay</a>
            </div>
            <button class="btn btn-trans text-gray floating-search-button" (click)="hideSearchBar()" *ngIf="searchBarVisible" aria-label="Close search bar">
                <svg role="img" aria-label="Close icon">
                    <use xlink:href="#icon-close"></use>
                </svg>
            </button>
        </div>
    </div>
    <div class="view-box-media__tab" *ngIf="filterTabObj.items.length > 1">
        <div class="view-box-media__tab-item" *ngFor="let tab of filterTabObj.items">
            <a href="javascript:void(0)" class="view-box-media__tab-link" [ngClass]="{'active': filterTabObj.tabActive === tab.id}" (click)="tabItemClick(tab.id)" role="button" tabindex="0" [attr.aria-label]="tab.label + 'tab'">
                {{tab.label}}
            </a>
        </div>
    </div>
    <div class="view-box-media__content" aria-live="polite">
        <scrollbar (onYReachEnd)="scrollReachEnd()" (onPositionChanged)="onPositionChanged()">
            <div *ngIf="uploaderViewModel.isError" class="gs-record-toast gsSlideInDown" role="alert" aria-live="assertive">
                <div class="gs-record-toast__content">{{uploaderViewModel.errorMsg}}</div>
            </div>

            <ng-container *ngIf="!isGalleryActivated">
                <phone-upload-panel *ngIf="showPhoneUpload"
                    [context]="phoneUploadContext"
                    [compact]="true"
                    (filesReceived)="onPhoneFilesReceived($event)">
                </phone-upload-panel>
                <form class="l-story-box-media" [class.l-story-box-media--empty-state]="showGalleryOffMessage" [formGroup]="form" aria-label="Media upload form">

                    <div class="gallery-empty-message" *ngIf="showGalleryOffMessage" role="status">
                        <i class="fas fa-images gallery-empty-message__icon" aria-hidden="true"></i>
                        <p class="gallery-empty-message__title">The gallery is turned off</p>
                        <p class="gallery-empty-message__text">
                            Turn on <strong>Enable gallery</strong> in Image Gallery settings, or upload a video or photo below.
                        </p>
                    </div>

                    <div class="media-grid" *ngIf="!showGalleryOffMessage">
                        <div class="media-slot" *ngFor="let item of slots">
                
                            <!-- 🔹 SKELETON UI -->
                            <div *ngIf="item.isSkeleton" class="media-skeleton">
                                <div class="media-skeleton__thumb"></div>
                            </div>
                
                            <!-- 🔹 MEDIA UI (your original HTML) -->
                            <label *ngIf="!item.isSkeleton"
                                   class="l-story-box-media__item_data pos-relative"
                                   [ngClass]="{
                                       'no-pointer': !item.isActive &&
                                       (totalDatainmedai == 10 || downloaded)
                                   }">
                
                                <div class="l-story-box-media__image_data"
                                     [ngClass]="{
                                         'no-pointer': !item.isActive &&
                                         (totalDatainmedai == 10 || downloaded)
                                     }">
                
                                    <span class="gallery-tile-loader" *ngIf="tileStatus(item) === 'loading'" aria-hidden="true">
                                        <i class="fas fa-spinner fa-pulse"></i>
                                    </span>
                                    <img class="gallery-tile-img"
                                         [class.is-ready]="tileStatus(item) === 'ready'"
                                         [attr.src]="tilePreview(item)"
                                         alt=""
                                         loading="lazy"
                                         decoding="async"
                                         (load)="onTileLoad(item)"
                                         (error)="onTileError(item, $event)">
                                </div>
                
                                <span class="l-story-box-media__checkbox"
                                      [ngClass]="{
                                          'no-pointer': !item.isActive &&
                                          (totalDatainmedai == 10 || downloaded)
                                      }">
                
                                    <input type="checkbox"
                                           [(ngModel)]="item.isActive"
                                           [ngModelOptions]="{standalone: true}"
                                           (change)="selectItem(item)"
                                           [attr.aria-label]="'Select media item ' + item.label">
                
                                    <span></span>
                                </span>
                            </label>
                
                        </div>
                    </div>
                
                    <!-- 🔹 DEFAULT MESSAGES -->
                    <div class="l-story-box-media__loading"
                         [hidden]="!isGalleriesLoading"
                         aria-live="polite">
                        Loading...
                    </div>
                
                    <div class="l-story-box-media__loading"
                         [hidden]="isGalleriesLoading || galleries.length > 0"
                         aria-live="polite">
                    </div>
                
                </form>
            </ng-container>

            <ng-container *ngIf="isGalleryActivated">
                <form class="l-story-box-media" [class.l-story-box-media--empty-state]="showNoGalleryState" [formGroup]="form" aria-label="Media upload form">
                    <div class="gallery-empty-message" *ngIf="showNoGalleryState" role="status">
                        <i class="fas fa-images gallery-empty-message__icon" aria-hidden="true"></i>
                        <ng-container *ngIf="isCampaignSelected; else noDefaultGallery">
                            <p class="gallery-empty-message__title">No gallery for this campaign</p>
                            <p class="gallery-empty-message__text">
                                Attach a gallery to this campaign in <strong>Campaign Settings</strong>, or upload a video or photo below.
                            </p>
                        </ng-container>
                        <ng-template #noDefaultGallery>
                            <p class="gallery-empty-message__title">No gallery images yet</p>
                            <p class="gallery-empty-message__text">
                                Choose <strong>Default gallery</strong> or set default galleries in Image Gallery settings, or upload a video or photo below.
                            </p>
                        </ng-template>
                    </div>
                    <ng-container *ngIf="useGroupedGalleries; else flatGalleryList">
                        <div class="photo-gallery-group mb-3" *ngFor="let group of photoGalleryGroups">
                            <label class="l-story-box-media__item pos-relative" [ngClass]="{'no-pointer': !media.isActive && (totalDatainmedai == 10 || downloaded) }" *ngFor="let media of group.items; trackBy: galleriesTrackByFnc">
                                <div class="l-story-box-media__image" [ngClass]="{'no-pointer': !media.isActive && (totalDatainmedai == 10 || downloaded) }">
                                    <span class="gallery-tile-loader" *ngIf="tileStatus(media) === 'loading'" aria-hidden="true">
                                        <i class="fas fa-spinner fa-pulse"></i>
                                    </span>
                                    <img class="gallery-tile-img" [class.is-ready]="tileStatus(media) === 'ready'" [attr.src]="tilePreview(media)" alt="" loading="lazy" decoding="async" (load)="onTileLoad(media)" (error)="onTileError(media, $event)">
                                </div>
                                <span class="l-story-box-media__checkbox" [ngClass]="{'no-pointer': !media.isActive && (totalDatainmedai == 10 ||  downloaded) }">
                                    <input type="checkbox" [(ngModel)]="media.isActive" [ngModelOptions]="{standalone: true}" (change)="selectItem (media)" [attr.aria-label]="'Select media item' + media.label">
                                    <span></span>
                                </span>
                            </label>
                            <div class="text-muted text-small photo-gallery-group__empty" *ngIf="!group.items?.length">No media in this gallery.</div>
                        </div>
                    </ng-container>
                    <ng-template #flatGalleryList>
                    <label class="l-story-box-media__item pos-relative" [ngClass]="{'no-pointer': !media.isActive && (totalDatainmedai == 10 || downloaded) }" *ngFor="let media of galleries; trackBy: galleriesTrackByFnc">
                        <div class="l-story-box-media__image" [ngClass]="{'no-pointer': !media.isActive && (totalDatainmedai == 10 || downloaded) }">
                            <span class="gallery-tile-loader" *ngIf="tileStatus(media) === 'loading'" aria-hidden="true">
                                <i class="fas fa-spinner fa-pulse"></i>
                            </span>
                            <img class="gallery-tile-img" [class.is-ready]="tileStatus(media) === 'ready'" [attr.src]="tilePreview(media)" alt="" loading="lazy" decoding="async" (load)="onTileLoad(media)" (error)="onTileError(media, $event)">
                        </div>
                        <span class="l-story-box-media__checkbox" [ngClass]="{'no-pointer': !media.isActive && (totalDatainmedai == 10 ||  downloaded) }">
                            <input type="checkbox" [(ngModel)]="media.isActive" [ngModelOptions]="{standalone: true}" (change)="selectItem (media)" [attr.aria-label]="'Select media item' + media.label">
                            <span></span>
                        </span>
                    </label>
                    </ng-template>
                    <div class="l-story-box-media__loading" [hidden]="!isGalleriesLoading" aria-live="polite">Loading...</div>
                    <div class="l-story-box-media__loading l-story-box-media__empty-hint" [hidden]="isGalleriesLoading || showNoGalleryState || galleries.length > 0 || (useGroupedGalleries && photoGalleryGroups.length > 0)" aria-live="polite">
                        No images match your search.
                    </div>
                </form>
    
            </ng-container>
        </scrollbar>
    </div>
    <div class="view-box-media__upload">
        <div class="gs-record-toolbar desktop_display" *ngIf="!isSmallScreen">
            <div [ngClass]="{'no-pointer': (totalDatainmedai == 10 || downloaded || disableSubmit) }" class="gs-record-camera">
                <!-- One entry point: the widget has Add from computer (direct path), drag and drop, Scan to Upload and cloud sources. -->
                <button class="btn btn_style_upload" (click)="uploadCloud()" aria-label="Add photos or videos"><i class="fa-solid fa-cloud-arrow-up" aria-hidden="true"></i>Add Media</button>
                <input type="file" #fileInput style="display: none;" accept="video/*,image/*" (change)="uploadDATA($event)" aria-label="Upload video and image file">
            </div>
            <div id="import-record-hippo-complete" [hidden]="true" (click)="importComplete('no')" aria-hidden="true"></div>
        </div>
        <div class="gs-record-toolbar__mobile" *ngIf="isSmallScreen">
            <div  (click)="active($event , 0)"   role="button" aria-label="Home">
                <div>
                  <button class="voicetext_button_mob" [ngClass]="{'background_highlight':!menuActive}" aria-label="Edit">
                    <i class="fa-solid fa-pencil"></i>
                  </button>
                </div>
              </div>
              <div  *ngIf="updatedMenu && updatedMenu.length"  (click)="activeTag($event)"   role="button" aria-label="Images">
                <div>
                  <button class="voicetext_button_mob" [ngClass]="{'background_highlight': menuActive && menuActive.id != 16}">
                    <i class="fa-solid fa-tag"></i>
                  </button>
                </div>
                <div class="l-story-flow-timeline__label d-none d-md-block">
                  <!-- {{ storyflowMenu[mediaIndex]?.title }} -->
                </div>
              </div>
              <!-- Media Options -->
            <div class="gs-record-camera__mobile">
                <span>
                    <button class="voicetext_button_mob"  (click)="triggerMobileFileInput()" aria-label="Open camera"><i class="fa-solid fa-camera" aria-hidden="true"></i></button>
                </span>

            </div>
            <div (click)="active($event, 16)" (keydown.enter)="active($event, 16)"   role="button" aria-label="Images">
                <div>
                  <button class="voicetext_button_mob background_highlight">
                    <i class="fa-solid fa-images"></i>
                  </button>
                </div>
                <div class="l-story-flow-timeline__label d-none d-md-block">
                  <!-- {{ storyflowMenu[mediaIndex]?.title }} -->
                </div>
              </div>
            <div class="dropdown-mobile" (click)="uploadCloud()">
                <span>
                    <button class="voicetext_button_mob" aria-label="Upload Image"><i class="fa-solid fa-cloud-arrow-up"></i></button>
                </span>
            </div>
          
            <div id="import-record-hippo-complete" [hidden]="true" (click)="importComplete('no')" aria-hidden="true"></div>
        </div>
        <div class="progress gallery-progress-bar" *ngIf="uploaderViewModel.isUploading">
            <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width': uploaderViewModel.progressCss}" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="uploaderViewModel.progressCss"></div>
        </div>
        <!-- <span class="canva-btn canva-btn-theme-light canva-btn-size-l" (click)="designCanva()" aria-label="Design with Canva">
            <span class="canva-btn-i"></span>
        </span> -->
        <div *ngIf="isShowRecorder" class="view-box-media__record">
            <recorder-media [videoduration]="videoduration" [camera]="isCamera" (onRecordFinish)="onRecordFinish($event)" (onClose)="onRecorderClose()" aria-label="Media recorder"></recorder-media>
        </div>
    </div>
    <mux-uploader id="my-uploader-gs" dynamic-chunk-size style="display: none;">
        <button class="btn" type="button" slot="file-select" aria-label="Select a file">Pick a file</button>
    </mux-uploader>
</div>

<div style="display: none;" id="cancelfle" (click)="cancelFile()"></div>
<!-- <input type="file" #fileInput style="display: none;" accept="video/*" (change)="uplpadImageAndVideo($event)"  accept="video/*,image/png,
                image/jpeg,
                image/jpg,
                image/webp,
                image/gif,
                image/heic,
                image/heif,
                image/bmp,
                image/tiff,
                image/avif" aria-label="Upload video file"> -->
<input type="file" #mobilefileInput  style="display: none;"  accept="video/*,image/png,
                image/jpeg,
                image/jpg,
                image/webp,
                image/gif,
                image/heic,
                image/heif,
                image/bmp,
                image/tiff,
                image/avif" (change)="uplpadImageAndVideo($event)" aria-label="Upload image or video file">

<ng-container *ngIf="isBrowser">
    <uc-config
    pubkey="52ceebe300b5bee7b70f"
    multiple="false"
    max-local-file-size-bytes="314572800"
    ctx-name="my-uploader"
    use-cloud-image-editor="true"
    [attr.source-list]="showPhoneUpload ? 'computer,phone,url,dropbox,gphotos,facebook,gdrive,box' : 'url,dropbox,gphotos,facebook,gdrive,box'"
     accept="video/*,image/png,
                image/jpeg,
                image/jpg,
                image/webp,
                image/gif,
                image/heic,
                image/heif,
                image/bmp,
                image/tiff,
                image/avif">
  </uc-config>
  <uc-file-uploader-regular
class="uc-light uploader-hidden"
ctx-name="my-uploader"
></uc-file-uploader-regular>

<uc-upload-ctx-provider ctx-name="my-uploader" id="my-uploader-provider"></uc-upload-ctx-provider>
</ng-container>

